import { FC } from "react";
import { Modal as BoostrapModal } from "react-bootstrap";
import { ModalProps } from "./types";
import style from "./style.module.scss";

export const Modal: FC<ModalProps> = (props) => {
  const { show, type, title, text, buttonText = "OK" } = props;
  const { handleCloseModal } = props;
  return (
    <BoostrapModal show={show} onHide={handleCloseModal} centered>
      <BoostrapModal.Body>
        <div className="d-flex flex-column align-items-center gap-3 m-4">
          <i
            className={`bi ${
              type === "error" ? "bi-x-circle" : "bi-check-circle"
            } ${style.icon} ${style[type]}`}
          ></i>
          <h6 className={style.title}>{title}</h6>
          <h6 className={style.description}>{text}</h6>
          <div>
            <button
              className="btn btn-primary submit-btn text-white w-100"
              onClick={handleCloseModal}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </BoostrapModal.Body>
    </BoostrapModal>
  );
};
